// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"82edea4b","264":"de6a1c7d","290":"ef28b177","358":"76701493","420":"8f6fb615","571":"17b32d5f","672":"29b15479"}[chunkId] + ".chunk.js";
};